const spaceRegex = / /g;
const unbreakableSpace = '\u00a0';

/**
 * Replaces normal spaces with non-breaking spaces.
 *
 * @param text - The text to transform.
 * @returns The text with non-breaking spaces.
 */
export const replaceSpacesWithUnbreakableSpaces = (text: string): string =>
    text.replace(spaceRegex, unbreakableSpace);
